import { FormattedNumber, useIntl } from 'react-intl';

import { FlexRow, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { emptyArray } from 'ui-components/default-props/empty';

import type { CustomsItem } from '../../../customs-declarations/types';
import { CustomsErrorBadge } from '../../../customs-declarations/components/error-badge';
import { getCustomsItemsCount } from '../../../customs-declarations/get-customs-item-count';
import { messages } from '../../../customs-declarations/messages';
import { OrdersSidebarSectionHeaderChip } from '../orders-sidebar-section-header-chip';
import ErrorBadgeWithTooltip from '../../../error-badge-with-tooltip';
import { messages as customsDocMessages } from '../../../../orders/order-details/fulfillment-plan/sections/customs-documents/messages';
import sectionStyle from '../orders-sidebar-section.module.less';
import style from './customs-section-header-content.module.less';

type CustomsSectionHeaderContentProps = {
  customsItems: CustomsItem[];
  isReadonly: boolean;
  isCarrierNotSupported?: boolean;
};

/**
 * Header content for the Customs Declarations sidebar section.
 */
export const CustomsSectionHeaderContent = ({ customsItems, isReadonly, isCarrierNotSupported }: CustomsSectionHeaderContentProps) => {
  const intl = useIntl();
  const customsItemsCount = getCustomsItemsCount(customsItems);

  const carrierWarningErrors = isCarrierNotSupported
    ? [intl.formatMessage(customsDocMessages.carrierDocumentUploadNotSupported)]
    : (emptyArray as string[]);

  return (
    <div className={sectionStyle['orders-sidebar-section-header-title-and-count']}>
      <Text textType={TextType.H4} value={messages.customsHeader} />
      <OrdersSidebarSectionHeaderChip>
        <FormattedNumber value={customsItemsCount} />
      </OrdersSidebarSectionHeaderChip>
      {!isReadonly && (
        <FlexRow className={style['error-badge']} gap={Gap.Space4}>
          <CustomsErrorBadge />
          <ErrorBadgeWithTooltip errors={carrierWarningErrors} layout='text-with-background' position='bottom-right' />
        </FlexRow>
      )}
    </div>
  );
};
